<div class="training-box" [class]="complianceTraining?.is_valid ? 'valid' : 'invalid'">
  @if (complianceTraining?.is_valid) {
    <mat-icon class="icon" fontSet="material-icons-outlined"> done </mat-icon>
  }
  @if (!complianceTraining?.is_valid && complianceTraining?.created_at) {
    <mat-icon class="icon" fontSet="material-icons-outlined"> hourglass_disabled </mat-icon>
  }
  @if (!complianceTraining?.is_valid && !complianceTraining?.created_at) {
    <mat-icon class="icon" fontSet="material-icons-outlined"> pending </mat-icon>
  }

  <div class="training-info">
    @if (!complianceTraining?.created_at) {
      <div>
        <span><b>Training missing</b></span>
      </div>
    }
    @if (complianceTraining?.created_at) {
      <div>
        <span>
          <b>Training {{ complianceTraining.is_valid ? 'valid' : 'expired' }}</b>
          <br />
          last completed on:
        </span>
        {{ complianceTraining.created_at | date: 'mediumDate' }}
        {{ complianceTraining.created_at | date: 'shortTime' }}
      </div>
    }
  </div>
</div>
